import React from "react";
import { Container } from "@/components/primitives";
import { PageHero } from "@/components/PageHero";
import { PrismBackground } from "@/components/Prism";
import { AXOR_EMAIL, AXOR_ADDRESS } from "@/config";

const Legal = ({ kind }) => {
  const isPrivacy = kind === "privacy";
  return (
    <>
      <PageHero
        overline="Legal"
        title={isPrivacy ? "Privacy Policy" : "Terms & Conditions"}
        testid={`${kind}-hero`}
      />
      <section className="relative overflow-hidden py-16 md:py-24">
        <PrismBackground />
        <Container className="relative max-w-3xl">
          <div className="space-y-8 text-axor-white/75">
            {isPrivacy ? (
              <>
                <p className="text-lg leading-relaxed">
                  Axor Technologies respects your privacy. This page explains how
                  we handle information shared with us through this website.
                </p>
                <div>
                  <h2 className="text-xl font-semibold text-axor-white">Information We Collect</h2>
                  <p className="mt-3 leading-relaxed">
                    This website does not use a database or store submissions on a
                    server. When you use our contact form or action buttons, your
                    details are used only to start a conversation with us over
                    WhatsApp or email. We do not sell or share your personal
                    information.
                  </p>
                </div>
                <div>
                  <h2 className="text-xl font-semibold text-axor-white">How We Use Information</h2>
                  <p className="mt-3 leading-relaxed">
                    Any information you choose to share is used solely to respond
                    to your inquiry and provide career and recruitment support.
                  </p>
                </div>
                <div>
                  <h2 className="text-xl font-semibold text-axor-white">Contact</h2>
                  <p className="mt-3 leading-relaxed">
                    For any privacy questions, contact us at{" "}
                    <a href={`mailto:${AXOR_EMAIL}`} className="text-axor-cyan hover:text-axor-turquoise">
                      {AXOR_EMAIL}
                    </a>{" "}
                    or by mail at {AXOR_ADDRESS}.
                  </p>
                </div>
              </>
            ) : (
              <>
                <p className="text-lg leading-relaxed">
                  By using this website, you agree to the following terms.
                </p>
                <div>
                  <h2 className="text-xl font-semibold text-axor-white">Use Of This Website</h2>
                  <p className="mt-3 leading-relaxed">
                    Content on this website is provided for general information
                    about Axor Technologies' career and recruitment services. Job
                    listings shown are illustrative unless otherwise confirmed.
                  </p>
                </div>
                <div>
                  <h2 className="text-xl font-semibold text-axor-white">No Guarantees</h2>
                  <p className="mt-3 leading-relaxed">
                    Axor Technologies does not guarantee employment, salary,
                    interviews, or any specific outcome. We provide guidance,
                    preparation and recruitment support.
                  </p>
                </div>
                <div>
                  <h2 className="text-xl font-semibold text-axor-white">Contact</h2>
                  <p className="mt-3 leading-relaxed">
                    Questions about these terms can be sent to{" "}
                    <a href={`mailto:${AXOR_EMAIL}`} className="text-axor-cyan hover:text-axor-turquoise">
                      {AXOR_EMAIL}
                    </a>
                    .
                  </p>
                </div>
              </>
            )}
          </div>
        </Container>
      </section>
    </>
  );
};

export const Privacy = () => <Legal kind="privacy" />;
export const Terms = () => <Legal kind="terms" />;
